import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { toast } from 'react-toastify';
import {
  CheckCircleIcon,
  XCircleIcon,
  DocumentTextIcon,
  CurrencyEuroIcon,
  ClockIcon,
  SparklesIcon,
  ExclamationTriangleIcon,
  PhotoIcon,
  ArrowPathIcon,
  CalendarIcon,
  TruckIcon,
  StarIcon,
  InformationCircleIcon,
  ChevronDownIcon,
  ChevronUpIcon
} from '@heroicons/react/24/outline';
import {
  CheckCircleIcon as CheckCircleIconSolid,
  XCircleIcon as XCircleIconSolid
} from '@heroicons/react/24/solid';
import API_CONFIG from '../../config/api';

// Componente per la card del singolo preventivo
const PreventivoCard = ({ 
  preventivo, 
  statoCorrente, 
  onSeleziona, 
  onAggiornaNote, 
  onReset,
  getVehicleImage,
  parseDatiOfferta,
  isExpanded,
  onToggleExpanded
}) => {
  const datiOfferta = parseDatiOfferta(preventivo.datiOfferta);
  const note = preventivo.note || '';

  return (
    <div 
      className={`relative overflow-hidden rounded-xl border-2 transition-all duration-300 ${
        statoCorrente === 'accettato' 
          ? 'border-green-300 bg-gradient-to-r from-green-50 to-emerald-50 shadow-lg shadow-green-100' 
          : statoCorrente === 'rifiutato'
          ? 'border-red-300 bg-gradient-to-r from-red-50 to-rose-50 shadow-lg shadow-red-100'
          : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-lg'
      }`}
    >
      {/* Badge stato nell'angolo */}
      {statoCorrente !== 'nessuna_azione' && (
        <div className={`absolute top-0 right-0 px-4 py-2 text-xs font-bold text-white z-10 ${
          statoCorrente === 'accettato' ? 'bg-green-500' : 'bg-red-500'
        }`} style={{clipPath: 'polygon(0 0, 100% 0, 100% 100%, 15% 100%)'}}>
          {statoCorrente === 'accettato' ? '✅ APPROVATO' : '❌ RIFIUTATO'}
        </div>
      )}
      
      <div className="p-6">
        {/* Header compatto */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-6 gap-4">
          <div className="flex items-center space-x-3">
            <div className={`p-2 rounded-full ${
              preventivo.tipoPreventivo === 'personalizzato' ? 'bg-purple-100' : 'bg-blue-100'
            }`}>
              {preventivo.tipoPreventivo === 'personalizzato' ? (
                <StarIcon className={`h-5 w-5 ${preventivo.tipoPreventivo === 'personalizzato' ? 'text-purple-600' : 'text-blue-600'}`} />
              ) : (
                <DocumentTextIcon className="h-5 w-5 text-blue-600" />
              )}
            </div>
            <div>
              <h4 className="text-lg font-bold text-gray-900">
                Preventivo #{preventivo.id}
              </h4>
              <div className="flex items-center space-x-3">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  preventivo.tipoPreventivo === 'personalizzato'
                    ? 'bg-purple-100 text-purple-800 border border-purple-200'
                    : 'bg-blue-100 text-blue-800 border border-blue-200'
                }`}>
                  {preventivo.tipoPreventivo === 'personalizzato' ? '✨ Personalizzato' : '📋 Standard'}
                </span>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                  preventivo.statoPreventivo === 'confermato'
                    ? 'bg-green-100 text-green-800 border border-green-200'
                    : 'bg-amber-100 text-amber-800 border border-amber-200'
                }`}>
                  {preventivo.statoPreventivo === 'confermato' ? '✅ Confermato' : '📤 Inviato'}
                </span>
              </div>
            </div>
          </div>
          
          {/* Pulsanti azione */}
          <div className="flex items-center space-x-2">
            <button
              onClick={() => onSeleziona(preventivo, 'accettato')}
              className={`flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 text-sm ${
                statoCorrente === 'accettato'
                  ? 'bg-green-600 text-white shadow-md'
                  : 'bg-white border-2 border-green-300 text-green-700 hover:bg-green-50'
              }`}
            >
              {statoCorrente === 'accettato' ? (
                <CheckCircleIconSolid className="h-4 w-4 mr-2" />
              ) : (
                <CheckCircleIcon className="h-4 w-4 mr-2" />
              )}
              {statoCorrente === 'accettato' ? 'Approvato' : 'Approva'}
            </button>
            
            <button
              onClick={() => onSeleziona(preventivo, 'rifiutato')}
              className={`flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 text-sm ${
                statoCorrente === 'rifiutato'
                  ? 'bg-red-600 text-white shadow-md'
                  : 'bg-white border-2 border-red-300 text-red-700 hover:bg-red-50'
              }`}
            >
              {statoCorrente === 'rifiutato' ? (
                <XCircleIconSolid className="h-4 w-4 mr-2" />
              ) : (
                <XCircleIcon className="h-4 w-4 mr-2" />
              )}
              {statoCorrente === 'rifiutato' ? 'Rifiutato' : 'Rifiuta'}
            </button>

            {(statoCorrente === 'accettato' || statoCorrente === 'rifiutato') && (
              <button
                onClick={() => onReset(preventivo.id)}
                className="flex items-center px-3 py-2 rounded-lg text-xs font-medium bg-gray-100 border border-gray-300 text-gray-600 hover:bg-gray-200 transition-colors"
                title="Rimuovi selezione"
              >
                <ArrowPathIcon className="h-3 w-3" />
              </button>
            )}
          </div>
        </div>

        {/* Contenuto principale espandibile */}
        <div className="space-y-4">
          {/* Preview informazioni principali (sempre visibile) */}
          <div className="flex flex-col sm:flex-row gap-4">
            {/* Immagine vettura compatta */}
            <div className="sm:w-32 sm:h-24 w-full h-32 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg overflow-hidden relative flex-shrink-0">
              {getVehicleImage(preventivo.vettura) ? (
                <img
                  src={getVehicleImage(preventivo.vettura)}
                  alt={`${preventivo.vettura?.brand || ''} ${preventivo.vettura?.modello || ''}`}
                  className="w-full h-full object-contain p-2"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect width='300' height='200' fill='%23e5e7eb'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='16' fill='%239ca3af'%3ENo Image%3C/text%3E%3C/svg%3E";
                  }}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <PhotoIcon className="h-8 w-8 text-blue-500" />
                </div>
              )}
            </div>

            {/* Informazioni principali */}
            <div className="flex-1 space-y-3">
              {/* Vettura */}
              {preventivo.vettura && (
                <div>
                  <h5 className="font-bold text-gray-900 text-lg">
                    {preventivo.vettura.brand} {preventivo.vettura.modello}
                  </h5>
                  <p className="text-sm text-gray-600">{preventivo.vettura.alimentazione}</p>
                </div>
              )}

              {/* Dettagli principali in layout compatto */}
              <div className="grid grid-cols-3 gap-3">
                <div className="text-center p-3 bg-white rounded-lg border border-gray-200">
                  <CurrencyEuroIcon className="h-5 w-5 text-green-600 mx-auto mb-1" />
                  <p className="text-lg font-bold text-gray-900">
                    €{parseFloat(datiOfferta.canone || 0).toLocaleString('it-IT')}
                  </p>
                  <p className="text-xs text-gray-500">al mese</p>
                </div>
                
                <div className="text-center p-3 bg-white rounded-lg border border-gray-200">
                  <ClockIcon className="h-5 w-5 text-blue-600 mx-auto mb-1" />
                  <p className="text-lg font-bold text-gray-900">{datiOfferta.durata || 0}</p>
                  <p className="text-xs text-gray-500">mesi</p>
                </div>
                
                <div className="text-center p-3 bg-white rounded-lg border border-gray-200">
                  <CurrencyEuroIcon className="h-5 w-5 text-orange-600 mx-auto mb-1" />
                  <p className="text-lg font-bold text-gray-900">
                    €{parseFloat(datiOfferta.anticipo || 0).toLocaleString('it-IT')}
                  </p>
                  <p className="text-xs text-gray-500">anticipo</p>
                </div>
              </div>
            </div>
          </div>

          {/* Pulsante per espandere/ridurre dettagli */}
          <button
            onClick={() => onToggleExpanded(preventivo.id)}
            className="w-full flex items-center justify-center py-2 text-sm text-gray-600 hover:text-gray-800 border-t border-gray-200"
          >
            {isExpanded ? (
              <>
                <ChevronUpIcon className="h-4 w-4 mr-1" />
                Mostra meno dettagli
              </>
            ) : (
              <>
                <ChevronDownIcon className="h-4 w-4 mr-1" />
                Mostra più dettagli
              </>
            )}
          </button>

          {/* Dettagli estesi (espandibili) */}
          {isExpanded && (
            <div className="space-y-4 pt-4 border-t border-gray-200">
              {/* Dettagli aggiuntivi */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {datiOfferta.kmAnnui && (
                  <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border">
                    <TruckIcon className="h-5 w-5 text-gray-600" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">
                        {parseFloat(datiOfferta.kmAnnui).toLocaleString('it-IT')} km/anno
                      </p>
                      <p className="text-xs text-gray-500">Chilometraggio incluso</p>
                    </div>
                  </div>
                )}

                {datiOfferta.settimaneConsegnaVettura && (
                  <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border">
                    <CalendarIcon className="h-5 w-5 text-gray-600" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">
                        {datiOfferta.settimaneConsegnaVettura} settimane
                      </p>
                      <p className="text-xs text-gray-500">Tempo di consegna</p>
                    </div>
                  </div>
                )}
              </div>

              {/* Servizi inclusi */}
              {datiOfferta.servizi && (
                <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <h6 className="font-semibold text-blue-900 mb-2">🔧 Servizi Inclusi</h6>
                  <div className="flex flex-wrap gap-2">
                    {(typeof datiOfferta.servizi === 'string' 
                      ? JSON.parse(datiOfferta.servizi) 
                      : datiOfferta.servizi
                    ).map((servizio, index) => (
                      <span key={index} className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full border border-blue-300">
                        {servizio}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Caratteristiche vettura */}
              {(datiOfferta.coloreVettura || datiOfferta.optionalVettura) && (
                <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <h6 className="font-semibold text-gray-900 mb-2">🚗 Caratteristiche Vettura</h6>
                  <div className="space-y-2 text-sm text-gray-700">
                    {datiOfferta.coloreVettura && (
                      <p><strong>Colori disponibili:</strong> {datiOfferta.coloreVettura}</p>
                    )}
                    {datiOfferta.optionalVettura && (
                      <p><strong>Optional inclusi:</strong> {datiOfferta.optionalVettura}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Campo Note (se preventivo selezionato) */}
          {(statoCorrente === 'accettato' || statoCorrente === 'rifiutato') && (
            <div className="pt-4 border-t border-gray-200">
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                💬 Note del cliente per questo preventivo
              </label>
              <textarea
                value={note}
                onChange={(e) => onAggiornaNote(preventivo.id, e.target.value)}
                placeholder={`Commenti specifici del cliente per il preventivo ${preventivo.tipoPreventivo}...`}
                rows="3"
                className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors placeholder-gray-400"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Componente principale
const ConfermaClienteConPreventivi = ({ idPratica, onConferma, onAnnulla }) => {
  const [preventivi, setPreventivi] = useState([]);
  const [preventiviSelezionati, setPreventiviSelezionati] = useState([]);
  const [expandedPreventiviMap, setExpandedPreventiviMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  // Carica i preventivi della pratica
  useEffect(() => {
    const caricaPreventivi = async () => {
      try {
        const response = await api.get(`/pratica/${idPratica}/preventivi`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        // Filtra i preventivi che possono essere approvati
        // Include: inviato, confermato, e anche bozza (per preventivi aggiunti dopo l'avanzamento stato)
        const preventiviApprovabili = (response.data.preventivi || []).filter(p => 
          ['inviato', 'confermato', 'bozza'].includes(p.statoPreventivo)
        );
        
        setPreventivi(preventiviApprovabili);
        
        // Auto-seleziona i preventivi già confermati
        const giàConfermati = preventiviApprovabili
          .filter(p => p.statoPreventivo === 'confermato')
          .map(p => ({ id: p.id, stato: 'accettato', note: '' }));
        
        setPreventiviSelezionati(giàConfermati);
        
      } catch (error) {
        console.error('Errore caricamento preventivi:', error);
        toast.error('Errore nel caricamento dei preventivi');
      } finally {
        setLoading(false);
      }
    };

    caricaPreventivi();
  }, [idPratica]);

  // Funzioni di utilità (mantenute dalla versione originale)
  const getVehicleImage = (vettura) => {
    if (!vettura) return null;
    
    if (vettura.immagine && typeof vettura.immagine === 'object' && vettura.immagine.path_file) {
      return `${window.location.origin}${vettura.immagine.path_file}`;
    }
    
    if (vettura.immagine && typeof vettura.immagine === 'string') {
      if (vettura.immagine.startsWith('http')) {
        return vettura.immagine;
      }
      if (vettura.immagine.startsWith('/')) {
        return `${window.location.origin}${vettura.immagine}`;
      }
      return `${API_CONFIG.baseURL}${vettura.immagine}`;
    }
    
    if (vettura.img && typeof vettura.img === 'string') {
      if (vettura.img.startsWith('http')) {
        return vettura.img;
      }
      if (vettura.img.startsWith('/')) {
        return `${window.location.origin}${vettura.img}`;
      } else if (vettura.img.startsWith('../')) {
        return vettura.img.replace('../', '/');
      }
      return vettura.img;
    }
    
    if (vettura.image && typeof vettura.image === 'string') {
      if (vettura.image.startsWith('http')) {
        return vettura.image;
      }
      if (vettura.image.startsWith('/')) {
        return `${window.location.origin}${vettura.image}`;
      }
      return `${API_CONFIG.baseURL}${vettura.image}`;
    }
    
    return null;
  };

  const parseDatiOfferta = (datiOfferta) => {
    try {
      if (typeof datiOfferta === 'string') {
        return JSON.parse(datiOfferta);
      }
      return datiOfferta || {};
    } catch (error) {
      return {};
    }
  };

  const handleSelezionaPreventivo = (preventivo, stato) => {
    const newSelection = [...preventiviSelezionati];
    const esistente = newSelection.findIndex(p => p.id === preventivo.id);
    
    if (esistente !== -1) {
      newSelection[esistente].stato = stato;
    } else {
      newSelection.push({
        id: preventivo.id,
        stato: stato,
        note: ''
      });
    }
    
    setPreventiviSelezionati(newSelection);
  };

  const aggiornaNote = (preventivoId, note) => {
    setPreventiviSelezionati(prev => 
      prev.map(p => p.id === preventivoId ? { ...p, note } : p)
    );
  };

  const handleResetSelezione = (preventivoId) => {
    const newSelection = preventiviSelezionati.filter(p => p.id !== preventivoId);
    setPreventiviSelezionati(newSelection);
  };

  const toggleExpanded = (preventivoId) => {
    setExpandedPreventiviMap(prev => ({
      ...prev,
      [preventivoId]: !prev[preventivoId]
    }));
  };

  const getStatoPreventivo = (preventivoId) => {
    const selezionato = preventiviSelezionati.find(p => p.id === preventivoId);
    return selezionato?.stato || 'nessuna_azione';
  };

  const handleConferma = async () => {
    const preventiviApprovati = preventiviSelezionati.filter(p => p.stato === 'accettato');
    
    if (preventiviApprovati.length === 0) {
      toast.error('Seleziona almeno un preventivo approvato dal cliente');
      return;
    }

    setSubmitting(true);
    try {
      await onConferma(preventiviApprovati);
    } catch (error) {
      console.error('Errore conferma:', error);
    } finally {
      setSubmitting(false);
    }
  };

  // Funzioni per selezione rapida
  const handleSelezionaTutti = () => {
    const tuttiApprovati = preventivi.map(p => ({
      id: p.id,
      stato: 'accettato',
      note: ''
    }));
    setPreventiviSelezionati(tuttiApprovati);
  };

  const handleDeselezionaTutti = () => {
    setPreventiviSelezionati([]);
  };

  // Loading state
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <div className="relative">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200"></div>
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-600 absolute top-0"></div>
        </div>
        <p className="mt-4 text-lg font-medium text-gray-700">Caricamento preventivi...</p>
        <p className="mt-1 text-sm text-gray-500">Analisi delle offerte disponibili</p>
      </div>
    );
  }

  // Empty state
  if (preventivi.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="bg-gray-100 rounded-full p-6 w-24 h-24 mx-auto mb-6 flex items-center justify-center">
          <DocumentTextIcon className="h-12 w-12 text-gray-400" />
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-3">Nessun preventivo disponibile</h3>
        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          Non ci sono preventivi inviati al cliente per questa pratica che possano essere approvati.
        </p>
        <button
          onClick={onAnnulla}
          className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
        >
          Chiudi
        </button>
      </div>
    );
  }

  const preventiviApprovati = preventiviSelezionati.filter(p => p.stato === 'accettato');
  const preventiviRifiutati = preventiviSelezionati.filter(p => p.stato === 'rifiutato');

  return (
    <div className="max-w-7xl mx-auto">
      {/* Header migliorato */}
      <div className="text-center border-b border-gray-200 pb-6 mb-8">
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-full p-3 w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <SparklesIcon className="h-8 w-8 text-white" />
        </div>
        <h3 className="text-3xl font-bold text-gray-900 mb-2">
          Approvazione Preventivi Cliente
        </h3>
        <p className="text-gray-600 max-w-3xl mx-auto text-lg">
          Gestisci le scelte del cliente sui preventivi presentati. Almeno un preventivo deve essere approvato per avanzare con la pratica.
        </p>
        
        {/* Statistiche e azioni rapide */}
        <div className="mt-6 flex flex-col lg:flex-row items-center justify-between bg-gray-50 rounded-xl p-4">
          <div className="flex items-center space-x-6 text-sm mb-4 lg:mb-0">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
              <span className="text-gray-700 font-medium">{preventivi.length} preventivi totali</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-gray-700 font-medium">{preventiviApprovati.length} approvati</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <span className="text-gray-700 font-medium">{preventiviRifiutati.length} rifiutati</span>
            </div>
          </div>
          
          {/* Pulsanti azione rapida */}
          <div className="flex items-center space-x-3">
            <button
              onClick={handleSelezionaTutti}
              className="px-4 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors text-sm font-medium"
            >
              ✅ Approva tutti
            </button>
            <button
              onClick={handleDeselezionaTutti}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium"
            >
              🔄 Reset tutto
            </button>
          </div>
        </div>
      </div>
      
      {/* Lista Preventivi migliorata */}
      <div className="space-y-6 mb-8">
        {preventivi.map((preventivo) => (
          <PreventivoCard
            key={preventivo.id}
            preventivo={preventivo}
            statoCorrente={getStatoPreventivo(preventivo.id)}
            onSeleziona={handleSelezionaPreventivo}
            onAggiornaNote={aggiornaNote}
            onReset={handleResetSelezione}
            getVehicleImage={getVehicleImage}
            parseDatiOfferta={parseDatiOfferta}
            isExpanded={expandedPreventiviMap[preventivo.id]}
            onToggleExpanded={toggleExpanded}
          />
        ))}
      </div>

      {/* Riepiloghi migliorati */}
      {(preventiviApprovati.length > 0 || preventiviRifiutati.length > 0) && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {/* Riepilogo Approvazioni */}
          {preventiviApprovati.length > 0 && (
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-green-500 rounded-full p-2">
                  <CheckCircleIconSolid className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-green-800">
                    Preventivi Approvati ({preventiviApprovati.length})
                  </h4>
                  <p className="text-sm text-green-600">Il cliente procederà con questi preventivi</p>
                </div>
              </div>
              <div className="space-y-3">
                {preventiviApprovati.map((sel) => {
                  const preventivo = preventivi.find(p => p.id === sel.id);
                  const dati = parseDatiOfferta(preventivo?.datiOfferta);
                  return (
                    <div key={sel.id} className="bg-white rounded-lg p-3 border border-green-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="font-semibold text-green-800">
                            Preventivo #{sel.id} • {preventivo?.tipoPreventivo}
                          </p>
                          <p className="text-sm text-green-600">
                            €{parseFloat(dati.canone || 0).toLocaleString('it-IT')} /mese • {dati.durata} mesi
                          </p>
                          {sel.note && (
                            <p className="text-xs text-green-700 mt-1 italic">"{sel.note}"</p>
                          )}
                        </div>
                        <CheckCircleIconSolid className="h-5 w-5 text-green-500" />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/* Riepilogo Rifiuti */}
          {preventiviRifiutati.length > 0 && (
            <div className="bg-gradient-to-r from-red-50 to-rose-50 border-2 border-red-200 rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="bg-red-500 rounded-full p-2">
                  <XCircleIconSolid className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-bold text-red-800">
                    Preventivi Rifiutati ({preventiviRifiutati.length})
                  </h4>
                  <p className="text-sm text-red-600">Il cliente non ha accettato questi preventivi</p>
                </div>
              </div>
              <div className="space-y-3">
                {preventiviRifiutati.map((sel) => {
                  const preventivo = preventivi.find(p => p.id === sel.id);
                  const dati = parseDatiOfferta(preventivo?.datiOfferta);
                  return (
                    <div key={sel.id} className="bg-white rounded-lg p-3 border border-red-200">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="font-semibold text-red-800">
                            Preventivo #{sel.id} • {preventivo?.tipoPreventivo}
                          </p>
                          <p className="text-sm text-red-600">
                            €{parseFloat(dati.canone || 0).toLocaleString('it-IT')} /mese • {dati.durata} mesi
                          </p>
                          {sel.note && (
                            <p className="text-xs text-red-700 mt-1 italic">"{sel.note}"</p>
                          )}
                        </div>
                        <XCircleIconSolid className="h-5 w-5 text-red-500" />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Alert migliorato */}
      {preventiviApprovati.length === 0 && preventiviSelezionati.length > 0 && (
        <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6 mb-8">
          <div className="flex items-start space-x-3">
            <ExclamationTriangleIcon className="h-6 w-6 text-amber-600 mt-1" />
            <div>
              <h4 className="font-semibold text-amber-800 mb-1">Attenzione: nessun preventivo approvato</h4>
              <p className="text-sm text-amber-700">
                Per procedere con la pratica, almeno un preventivo deve essere approvato dal cliente. 
                Al momento hai solo rifiutato {preventiviRifiutati.length} preventivo{preventiviRifiutati.length !== 1 ? 'i' : ''}.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Alert se nessuna selezione */}
      {preventiviSelezionati.length === 0 && (
        <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 mb-8">
          <div className="flex items-start space-x-3">
            <InformationCircleIcon className="h-6 w-6 text-blue-600 mt-1" />
            <div>
              <h4 className="font-semibold text-blue-800 mb-1">Seleziona la risposta del cliente</h4>
              <p className="text-sm text-blue-700">
                Indica per ogni preventivo se il cliente lo ha approvato o rifiutato. 
                Puoi usare i pulsanti "Approva tutti" o selezionare individualmente.
              </p>
            </div>
          </div>
        </div>
      )}
      
      {/* Footer Azioni migliorato */}
      <div className="sticky bottom-0 bg-white border-t-2 border-gray-200 -mx-8 -mb-8 px-8 py-6 rounded-b-xl shadow-lg">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-4">
          <button
            onClick={onAnnulla}
            className="px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-colors font-medium order-2 lg:order-1"
            disabled={submitting}
          >
            Annulla
          </button>
          
          <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-6 order-1 lg:order-2">
            {preventiviApprovati.length > 0 && (
              <div className="text-center lg:text-right">
                <p className="text-sm text-gray-600">Procedi con</p>
                <p className="font-bold text-gray-900 text-lg">
                  {preventiviApprovati.length} preventivi approvati
                </p>
                <p className="text-xs text-gray-500">
                  La pratica avanzerà ad "Attesa Documenti Cliente"
                </p>
              </div>
            )}
            
            <button
              onClick={handleConferma}
              disabled={preventiviApprovati.length === 0 || submitting}
              className={`px-8 py-4 rounded-xl font-semibold transition-all duration-200 transform text-lg ${
                preventiviApprovati.length === 0 || submitting
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-gradient-to-r from-green-600 to-green-700 text-white hover:from-green-700 hover:to-green-800 hover:scale-105 shadow-lg hover:shadow-xl'
              }`}
            >
              {submitting ? (
                <div className="flex items-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent mr-3"></div>
                  Elaborazione...
                </div>
              ) : (
                `✅ Conferma Cliente (${preventiviApprovati.length} approvati)`
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfermaClienteConPreventivi; 